import { Model, Attr, BelongsTo } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import Caretaker from '@/models/Caretaker'

@Model()
export default class SorewardsNegotiatedRate extends ApplicationRecord {
  static jsonapiType = 'sorewards_negotiated_rates'

  @Attr() id!: string
  @Attr() issuePhysical!: number
  @Attr() issueVirtual!: number
  @Attr() shipUnit!: number
  @Attr() shipGrouped!: number
  @Attr() loadFlat!: number
  @Attr() loadPct!: number
  @Attr() validUntil!: string

  @BelongsTo() caretaker!: Caretaker
}
